<template>
	<span class="tag px-1 fs-5 rounded" :class="componentClass">
		<slot name="default"></slot>
	</span>
</template>

<script>

export default {
	name: "tag",
	props: {
		mono: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		dark: {
			type: Boolean,
			default: false,
		}
	},
	data: () => ({}),
	computed: {
		componentClass() {
			const c = [];
			if ( this.mono ) c.push("--mono");
			if ( this.active ) c.push("--active");
			if ( this.dark ) c.push("white--text");

			return c.length ? c : null;
		},
	}
}
</script>

<style lang="scss">
.tag {
	position: relative;
	top: -1px;
	display: inline-block;
	height: 13px;
	/*font-size: $font-size-5;
	line-height: 100%;*/
	/*&.grey {
		background: map-get($grey, "lighten-2");
	}*/
	&.--mono {
		font-family: 'Courier New', Courier, monospace;
	}
	&.--active {
		//opacity: $default-hover-opacity;
		background-color: map-get($grey, "lighten-2");
		cursor:pointer;
		@include transition();

		&:hover {
			//opacity: 1;
			background-color: map-get($grey, "lighten-1");
		}
	}
}
</style>